import type { U2000CriteriaStaticOption } from '../../basic/U2000BasicTableList';

/** Clé registre — types d'opération lot (initLU U3142). */
export const U2000_CRITERIA_INIT_OPTIONS_U3142_LOT_DETAIL_OPERATION_TYPES =
  'U3142/lotDetailOperationTypes';

/** Clé registre — natures de travail actives (initLU U3139). */
export const U2000_CRITERIA_INIT_OPTIONS_U3139_WORK_NATURES = 'U3139/workNatures';
/** Clé registre — natures de travail actives par id (critère workNature.id U3139). */
export const U2000_CRITERIA_INIT_OPTIONS_U3139_WORK_NATURES_ID = 'U3139/workNaturesById';
/** Clé registre — familles actives (initLU U3155 — BL-0694). */
export const U2000_CRITERIA_INIT_OPTIONS_U3155_FAMILIES = 'U3155/families';
/** Clé registre — familles actives (initLU U3139 — BL-0694). */
export const U2000_CRITERIA_INIT_OPTIONS_U3139_FAMILIES = 'U3139/families';
/** Clé registre — anciens codes nature minutes (concordance T0008 — BL-0694). */
export const U2000_CRITERIA_INIT_OPTIONS_U3139_LEGACY_WORK_NATURE_CODES = 'U3139/legacyWorkNatureCodes';
/** Clé registre — natures de document facture (initLU U3125 — BL-0432). */
export const U2000_CRITERIA_INIT_OPTIONS_U3125_DOCUMENT_NATURES = 'U3125/documentNatures';

export type U2000CriteriaInitOptionsResolver = () => U2000CriteriaStaticOption[];

const registry = new Map<string, U2000CriteriaInitOptionsResolver>();

export function registerCriteriaInitOptionsResolver(
  optionsKey: string,
  resolver: U2000CriteriaInitOptionsResolver,
): void {
  registry.set(optionsKey, resolver);
}

export function unregisterCriteriaInitOptionsResolver(optionsKey: string): void {
  registry.delete(optionsKey);
}

export function resolveCriteriaInitOptions(optionsKey: string): U2000CriteriaStaticOption[] {
  const resolver = registry.get(optionsKey);
  return resolver ? resolver() : [];
}

/** Libellé affiché pour un critère initLU (réhydratation si displayValue absent). */
export function formatInitCriteriaDisplayValue(
  value: unknown,
  optionsKey: string,
): string {
  if (value == null || value === '') return '';
  const options = resolveCriteriaInitOptions(optionsKey);
  const match = options.find((o) => o.value === String(value));
  return match?.label ?? String(value);
}
